import { Skeleton } from "@mui/material";
import styles from "./style.module.scss";

interface DeltaBadgeSkeletonProps {
  /** Mirrors the caption slot so the tile keeps the same height while loading. */
  withCaption?: boolean;
}

function DeltaBadgeSkeleton({ withCaption = true }: DeltaBadgeSkeletonProps) {
  return (
    <span className={styles.wrap}>
      <Skeleton variant="rounded" width={62} height={20} sx={{ borderRadius: "12px" }} />
      {withCaption && <Skeleton variant="text" width={92} height={16} />}
    </span>
  );
}

export default DeltaBadgeSkeleton;
